const {
  REACT_APP_API_ENDPOINT,
  REACT_APP_API_BASE_URL,
  REACT_APP_CONTACT_FORM_WEBHOOK_URL,
} = process.env;

export const BASE_URL_API =
  REACT_APP_API_BASE_URL || `https://${REACT_APP_API_ENDPOINT}`;
export const CONTACT_FORM_WEBHOOK_URL =
  REACT_APP_CONTACT_FORM_WEBHOOK_URL ||
  'https://xmkh5acco2.execute-api.us-east-1.amazonaws.com/default/achieveapex-automation-run-webhook-to-sqs?run=aaddc7ef-d59e-4142-b84b-adc3e53f592d';
export const DEFAULT_AVATAR_IMAGE = "/images/placeholder.png";
export const DEFAULT_IMAGE = "/images/placeholder.png";
export const DEFAULT_COVER = "/images/home.png";
export const DEFAULT_COVER_CONTACT = "/images/contact.png";
export const URL_S3 = "https://construcaribe.s3.amazonaws.com";
export const API_KEY_GOOGLE_MAPS = 'AIzaSyB58IBxTIBI1vYD08Js_NtrbirXM6OkhtY';
export const URL_AUTHENTICATION = '/authentication';
